import { COLOR_ERROR } from '@elfsight/widget-form-builder/widget';
import { widgetButtonDefaults } from '@elfsight/widget-ui';
import type { FormAppearance } from '../../../types';

export const defaultFormAppearance: FormAppearance = {
  fieldActiveColor: 'rgb(25, 123, 255)',
  fieldLabelPosition: 'inside',
  fieldHeadingColor: 'rgb(17, 17, 17)',
  fieldInsideLabelColor: 'rgba(17, 17, 17, 0.5)',
  fieldLabelColor: 'rgb(17, 17, 17)',
  fieldColor: 'rgb(17, 17, 17)',
  fieldHintColor: 'rgba(17, 17, 17, 0.5)',
  fieldFillColor: 'transparent',
  fieldBorderType: 'outline',
  fieldBorderWidth: 1,
  fieldBorderRadius: 4,
  fieldBorderColor: 'rgba(17, 17, 17, 0.2)',
  fieldHeadingFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal'
  },
  fieldInsideLabelFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal'
  },
  fieldLabelFontStyle: {
    fontSize: 15,
    fontWeight: 'bold',
    fontStyle: 'normal'
  },
  fieldFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal'
  },
  fieldHintFontStyle: {
    fontSize: 13
  },
  fieldSpacing: 20,
  submitMessageAlignment: 'center',
  submitMessageTitleColor: 'rgb(17, 17, 17)',
  submitMessageTextColor: 'rgba(17, 17, 17, 0.5)',
  submitMessageButtonColor: 'rgb(25, 123, 255)',
  submitMessageTitleFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal'
  },
  submitMessageTextFontStyle: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal'
  },
  submitButtonProps: {
    ...widgetButtonDefaults,
    horizontalPadding: 24,
    verticalPadding: 11,
    font: {
      fontSize: 16,
      fontWeight: 700
    },
    fullWidth: true
  },
  submitButtonAlignment: 'center',
  widgetFooterTextColor: 'rgba(17, 17, 17, 0.5)',
  widgetFooterLinksColor: 'rgb(25, 123, 255)',
  widgetFooterTextStyle: {
    fontSize: 13
  },
  errorColor: COLOR_ERROR,
  successColor: 'rgb(14, 139, 37)'
};
